import { render, staticRenderFns } from "./EditPropCategory.vue?vue&type=template&id=41e4d26e"
import script from "./EditPropCategory.vue?vue&type=script&lang=js"
export * from "./EditPropCategory.vue?vue&type=script&lang=js"
import style0 from "./EditPropCategory.vue?vue&type=style&index=0&id=41e4d26e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports